import { DETERMINAR_PAGINA_ATUAL_SELECAO_EMPRESA } from '../types';

export default function determinarPaginaAtualSelecaoEmpresa(paginaAtual) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_SELECAO_EMPRESA,
    payload: paginaAtual
  };
}
